import { FieldRenderProps, useField } from 'react-final-form';
import {
  FormControl, FormErrorMessage, FormHelperText, HStack, Input, Text, useColorModeValue, VStack,
} from '@chakra-ui/react';
import React from 'react';
import FieldLabel from './FieldLabel';

type Props = FieldRenderProps<string, any>;
export const TextInput: React.FC<Props> = ({
  input, required, label, meta, numberFormat: boolean, ...rest
}: Props) => (
  <VStack align="left" justify="left" w="full">
    <HStack>
      <Text fontSize="sm" color="brand.700" pr={1}>
        {label}
        {required ? ' *' : ''}
      </Text>
      {meta.error && meta.touched
        && <Text fontSize="sm" color="red.400" pr={1}>{meta.error}</Text>}
    </HStack>
    {/* item 406 — brand.50 (pale tint) was near-invisible as a focus cue in light mode;
        the action palette's 400 reads in both modes. Errors likewise red.200 → red.400. */}
    <Input type="text" {...input} {...rest} focusBorderColor={meta.error ? 'red.400' : 'brandGreen.400'} />
  </VStack>
);

interface TextInputControlProps {
  name: string;
  label: string;
  isRequired?: boolean;
  disabled?: boolean;
  placeholder?: string;
  // item 254 — optional plain-language explainer under the field (legible in both skins)
  helperText?: string;
}
const TextInputControl: React.FC<TextInputControlProps> = ({
  name, label, isRequired, disabled, placeholder, helperText,
}) => {
  const { input, error, touched } = useField(name);
  const helpColor = useColorModeValue('gray.600', 'whiteAlpha.700');
  return (
    <FormControl isInvalid={error && touched} isRequired={isRequired}>
      <FieldLabel htmlFor={name}>{label}</FieldLabel>
      <Input
        {...input}
        isInvalid={error && touched}
        id={name}
        placeholder={placeholder ?? label}
        disabled={disabled}
      />
      {helperText && <FormHelperText color={helpColor}>{helperText}</FormHelperText>}
      <FormErrorMessage>{error}</FormErrorMessage>
    </FormControl>
  );
};
TextInputControl.defaultProps = {
  isRequired: false,
  disabled: false,
  placeholder: undefined,
  helperText: undefined,
};
export default TextInputControl;
